export default __webpack_public_path__ + "static/houseCard-7c818ea46df0f5b321346da637536204.jpg";